import { useEffect, useState } from "react";
import { TwentyIcCreditCoins } from "../../../ui/components/TwentyIcCreditCoins";
import "../Employee/CreditManagementEmployee.css";
import { BaseTab } from "../../../ui/components/BaseTab";
import "../Employee/CreditManagementEmployee.css";
import { Button, Space, Table } from "antd";
import Card from "antd/es/card/Card";
import { TwentyIcStatLine } from "../../../ui/components/icons/TwentyIcStatLine";
import { TwentyIcCreditsCoinsAdd } from "../../../ui/components/icons/TwentyIcCreditsCoinsAdd/TwentyIcCreditsCoinsAdd";
import { TwentyIcCalendarSeet } from "../../../ui/components/icons/TwentyIcCalendarSeet";
import { ColumnsType } from "antd/es/table";
import User from "../../../ui/components/User/User";
import {
  CreditHistory,
  creditHistorySelector,
  getMyAdminRechargeAsync,
  Movimento,
} from "../CreditHistorySlice";
import {
  TransactionSlice,
  getTransactionsAsync,
  transactionSelector,
} from "../TransactionSlice/TransactionSlice";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { useAppSelector } from "../../../app/hooks";
import { store } from "../../../app/store";
import {
  Wallet,
  getWalletAsync,
  walletSelector,
} from "../../Wallet/WalletSlice";
import { TwentyIcArrowLineDiagonal } from "../../../ui/components/icons/TwentyIcArrowLineDiagonal/TwentyIcArrowLineDiagonal";
import { addDotToNumber } from "../../../utils/utils";
import { TwentyIcArrowsLineSortVertical } from "../../../ui/components/icons/TwentyIcArrowsLineSortVertical";
import { TwentyIcStatBox } from "../../../ui/components/icons/TwentyIcStatBox";
import { TransactionRechargeModal } from "../TransactionDetailsModal/TransactionRechargeModal";
import { getTransactionDetailsAsync } from "../TransactionSlice/TransactionDetailsSlice";
import _ from "lodash";
import {
  getSpentCreditsAsync,
  SpentCredit,
  spentCreditsSelector,
} from "../SpentCreditsSlice";

export const CreditManagementEmployee = () => {
  const userId = localStorage.getItem("customerId");
  const [elementSelected, setElementSelected] = useState(0);
  const [wallet, setWallet] = useState<Wallet>();
  const spentCredits: SpentCredit[] = useAppSelector(
    spentCreditsSelector.selectAll
  );
  const creditHistory: CreditHistory[] = useAppSelector(
    creditHistorySelector.selectAll
  );

  const [detailsId, setDetailsId] = useState<number>(-1);

  const [openModalRechargeDetails, setOpenModalRechargeDetails] =
    useState(false);

  const transactions: TransactionSlice[] = useAppSelector(
    transactionSelector.selectAll
  );

  const [transaction, setTransaction] = useState<any>();

  let userTemp = "";

  useEffect(() => {
    if (!_.isEmpty(transactions)) {
      const foundTransaction = transactions.find((el) => el.id === detailsId);
      if (foundTransaction !== undefined) {
        setTransaction(foundTransaction);
        store.dispatch(
          getTransactionDetailsAsync({
            transactionalSummaryId: detailsId,
          })
        );
      }
    }
  }, [detailsId]);

  useEffect(() => {
    const tenantId = localStorage.getItem("tenantId");
    store.dispatch(getMyAdminRechargeAsync(Number.parseInt(userId ?? "0")));
    store.dispatch(getTransactionsAsync());
    store.dispatch(
      getSpentCreditsAsync({
        tenantId: Number.parseInt(tenantId ?? "0"),
        userId: Number.parseInt(userId ?? "0"),
      })
    );
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: "Mittente",
      key: "is",
      render: (element: CreditHistory) => {
        const words = [
          element.user.firstname ?? "",

          element.user.lastname ?? "",
        ];
        const firstWord = words[0] || "";
        const secondWord = words[1] || "";
        const initials = `${firstWord.charAt(0)}${secondWord.charAt(0)}`;
        userTemp = initials;
        return (
          <div className="myteam-table-user">
            {firstWord !== "" && secondWord !== "" ? (
              <User name={initials} round={true} size="l" />
            ) : (
              <div
                style={{
                  height: "36px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                -
              </div>
            )}
            <div className="myteam-table-user-name">
              {words[0] + " " + words[1]}
            </div>
          </div>
        );
      },
    },
    {
      title: "C. Tot. caricati",
      dataIndex: "totalRecharge",
      key: "",
      render: (text) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <TwentyIcCreditCoins
              className={undefined}
              color={"#7a7d7f"}
              colorC={"#7a7d7f"}
            />
            <div className="input-text-style-table-first">{text ?? ""}</div>
          </div>
        );
      },
    },
    {
      title: "Data",
      dataIndex: "date",
      key: "",
      render: (element: Date) => {
        const newDate = new Date(element);
        return (
          <div className="credit-table-last-recharge-container-employee">
            <div className="input-text-style-table-first">
              {element !== null &&
                newDate.getDate() +
                  "." +
                  (newDate.getMonth() + 1) +
                  "." +
                  newDate.getFullYear()}
            </div>
          </div>
        );
      },
    },
  ];

  const columnsMovimenti: ColumnsType<SpentCredit> = [
    {
      title: "Prodotto acquistato",
      dataIndex: "productName",
      key: "productName",
      render: (text) => {
        return (
          <div className="input-text-style-table-first">{text ?? "-"}</div>
        );
      },
    },
    {
      title: "Fornitore",
      dataIndex: "fornitore",
      key: "fornitore",
      render: (text) => {
        return (
          <div className="input-text-style-table-first">{text ?? "-"}</div>
        );
      },
    },
    {
      title: "Crediti spesi",
      dataIndex: "creditsSpent",
      key: "creditsSpent",
      render: (text) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <TwentyIcCreditCoins
              className={undefined}
              color={"#7a7d7f"}
              colorC={"#7a7d7f"}
            />
            <div className="input-text-style-table-first">-{text ?? "0"}</div>
          </div>
        );
      },
    },
    {
      title: "Data",
      dataIndex: "date",
      key: "date",
      render: (element: string) => {
        const newDate = new Date(element);
        const hours = String(newDate.getHours()).padStart(2, "0");
        const minutes = String(newDate.getMinutes()).padStart(2, "0");
        return (
          <div className="credit-table-last-recharge-container-employee">
            <div className="input-text-style-table-first">
              {element !== null &&
                newDate.getDate() +
                  "." +
                  (newDate.getMonth() + 1) +
                  "." +
                  newDate.getFullYear() +
                  " " +
                  hours +
                  ":" +
                  minutes}
            </div>
          </div>
        );
      },
    },
  ];

  const convertTypeIcon = (type: string) => {
    if (type === "SENT") {
      return <TwentyIcArrowLineDiagonal className={undefined} color="gray" />;
    } else if (type === "RECEIVED") {
      return (
        <TwentyIcCreditsCoinsAdd
          className={undefined}
          color="gray"
          colorC="gray"
        />
      );
    } else if (type === "RECHARGED") {
      return (
        <TwentyIcCreditsCoinsAdd
          className={undefined}
          color="gray"
          colorC="gray"
        />
      );
    } else {
      return null;
    }
  };

  const creditManagemenTable = (type: string) => {
    if (type === "SENT") {
      return "";
    } else {
      return "+";
    }
  };

  const columnsActivity: ColumnsType<TransactionSlice> = [
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
      render: (type, record) => (
        <>
          <div className="table-activity-type">
            {convertTypeIcon(record?.type)}
            <div className="table-activity-type-text">
              {convertType(record?.type)}
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Crediti Inviati",
      dataIndex: "totalCreditSent",
      key: "totalCreditSent",
      render: (totalCreditSent, record) => (
        <>
          <div className="table-activity-credit">
            <TwentyIcCreditsCoinsAdd
              className={undefined}
              color="gray"
              colorC="gray"
            />
            <div className="table-activity-credit-text">
              {creditManagemenTable(record?.type) + record?.totalCreditSent}
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Data",
      dataIndex: "date",
      key: "date",
      render: (date, record) => (
        <>
          <div className="table-activity-date">
            {convertDate(record?.date?.toString())}
          </div>
        </>
      ),
    },
    {
      title: "Ora",
      dataIndex: "date",
      key: "date",
      render: (date, record) => (
        <>
          <div
            className="table-activity-date"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "40px",
            }}
          >
            {convertTimestamp(record?.date?.toString())}
          </div>
        </>
      ),
    },
  ];

  const convertType = (type: string) => {
    if (type === "SENT") {
      return "Uscita";
    } else if (type === "RECEIVED") {
      return "Entrata";
    } else if (type === "RECHARGED") {
      return "Ricarica";
    } else {
      return null;
    }
  };

  const creditManagement = (type: string) => {
    if (type === "SENT") {
      return "-";
    } else {
      return "+";
    }
  };

  const convertTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return `${hour}:${minute} `;
  };

  const capitalize = (s: string) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  const convertDate = (inputDate: string) => {
    const parsedDate = parseISO(inputDate);

    const formattedDate = format(parsedDate, "EEE. dd MMM yyyy", {
      locale: it,
    }).replace(/(\b[a-z](?!\.))/g, (x) => capitalize(x));

    return formattedDate;
  };

  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");

  const name = firstName + " " + lastName + " " + "(io)";

  const wallets: Wallet[] = useAppSelector(walletSelector.selectAll);

  useEffect(() => {
    store.dispatch(getWalletAsync());
  }, []);

  useEffect(() => {
    setWallet(wallets[0]);
  }, [wallets]);

  return (
    <div className="credit-content">
      <div className="credit-topbar">
        <div className="credit-topbar-title-iconplace">
          <TwentyIcCreditCoins className="" color="#36B39E" colorC="#36B39E" />
        </div>
        <div className="credit-topbar-title">I miei crediti</div>
      </div>
      <div className="credit-header">
        <div className="credit-switchbar-tabs">
          <BaseTab
            select={elementSelected === 0}
            text="Stato attuale"
            onClick={() => {
              setElementSelected(0);
            }}
          ></BaseTab>
          <BaseTab
            select={elementSelected === 1}
            text="Attività"
            onClick={() => {
              setElementSelected(1);
            }}
          ></BaseTab>
          {/* <BaseTab
            select={elementSelected === 2}
            text="Richieste"
            onClick={() => {
              setElementSelected(2);
            }}
          ></BaseTab> */}
        </div>
      </div>
      {elementSelected === 0 && (
        <>
          <div className="container-cards-employee">
            <div className="first-card-credits">
              <Card>
                <div className="first-row">
                  <div className="total-credit-topbar">
                    <div className="total-credit-topbar-title-iconplace">
                      <TwentyIcStatLine className="" color="#36B39E" />
                    </div>
                    <div className="total-credit-topbar-title">
                      Crediti totali
                    </div>
                  </div>
                  {/* @TODO to be unlocked when feature will be avaialable on design  
              <div className="button-recharge-credits">
                <Button
                  style={{
                    borderColor: "#D3D4D4",
                    boxShadow: "none",
                    height: "100%",
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                  onClick={() => {}}
                >
                  <Space style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <TwentyIcCreditsCoinsAdd
                        color="#222729"
                        className={undefined}
                        colorC="#222729"
                      ></TwentyIcCreditsCoinsAdd>
                    </div>
                    <div className="placeholder-credit-recharge">
                      Fai una richiesta
                    </div>
                  </Space>
                </Button>
              </div> */}
                </div>
                <div className="credits-available-text">
                  Crediti disponibili
                </div>
                <div className="credits-view">
                  {wallet && wallet.currentCredits
                    ? addDotToNumber(wallet.currentCredits)
                    : "0"}
                </div>
                <div className="bottom-info">
                  <div className="last-movement-text">
                    Ultimo movimento
                    <div className="row-last-movement">
                      <div className="last-movement-icon">
                        <TwentyIcArrowLineDiagonal
                          color="#7a7d7f"
                          className={undefined}
                        ></TwentyIcArrowLineDiagonal>
                      </div>
                      <div className="last-movement-price">
                        {transactions.length > 0
                          ? creditManagement(transactions[0]?.type) +
                            transactions[0]?.totalCreditSent
                          : "--"}
                      </div>
                    </div>
                  </div>
                  <div className="date-text">
                    Data
                    <div className="row-date">
                      <div className="date-icon">
                        <TwentyIcCalendarSeet
                          color="#7a7d7f"
                          className={undefined}
                        ></TwentyIcCalendarSeet>
                      </div>
                      <div className="date-price">
                        {transactions[0]
                          ? convertDate(transactions[0].date.toString())
                          : "--"}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div className="second-card-credits">
              <Card>
                <div className="first-row">
                  <div className="movement-topbar">
                    <div className="movement-topbar-title-iconplace">
                      <TwentyIcArrowsLineSortVertical
                        className=""
                        color="#E5B85C"
                      />
                    </div>
                    <div className="movement-topbar-title">Movimenti</div>
                  </div>
                  <div className="button-activity-view">
                    <Button
                      style={{
                        borderColor: "#D3D4D4",
                        boxShadow: "none",
                        height: "100%",
                        display: "flex",
                        gap: "4px",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setElementSelected(1);
                      }}
                    >
                      <Space style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <TwentyIcStatBox
                            color="#7a7d7f"
                            className={undefined}
                          ></TwentyIcStatBox>
                        </div>
                        <div className="placeholder-credit-recharge">
                          Vedi attività
                        </div>
                      </Space>
                    </Button>
                  </div>
                </div>
                <div className="transaction-list">
                  {transactions.slice(0, 4).map((transaction, index) => (
                    <div key={transaction.uuid}>
                      <div className="view-transactions">
                        <div className="transaction-icon">
                          <TwentyIcCreditsCoinsAdd
                            className={undefined}
                            color="gray"
                            colorC="gray"
                          />
                        </div>

                        <div className="transaction-credits">
                          {creditManagement(transaction?.type) +
                            transaction?.totalCreditSent}
                        </div>
                        <div className="transaction-type">
                          {transaction?.type === "RECHARGED"
                            ? name
                            : transaction?.type === "RECEIVED"
                            ? "Admin"
                            : ""}
                        </div>
                        <div className="transaction-date">
                          {convertDate(transaction?.date?.toString())}
                        </div>
                        <div className="transaction-time">
                          {convertTimestamp(transaction?.date?.toString())}
                        </div>
                      </div>
                      {index !== transactions.slice(0, 4).length - 1 && (
                        <div className="rectangle-12" />
                      )}
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          </div>
          <div className="sending-history">
            <div className="sending-history-text">Movimenti</div>
            <div className="table-sending">
              <Table
                dataSource={spentCredits}
                columns={columnsMovimenti}
                pagination={{
                  pageSize: 12,
                }}
              ></Table>
            </div>
          </div>
          <div className="sending-history">
            <div className="sending-history-text">Storico crediti</div>
            <div className="table-sending">
              <Table
                dataSource={creditHistory}
                columns={columns}
                pagination={{
                  pageSize: 12,
                }}
              ></Table>
            </div>
          </div>
        </>
      )}{" "}
      {elementSelected === 1 && (
        <div className="sending-history">
          <div className="sending-history-text">Attività</div>
          <div className="table-sending">
            <Table
              columns={columnsActivity}
              dataSource={transactions}
              pagination={{
                pageSize: 12,
              }}
            ></Table>
          </div>
        </div>
      )}
      {openModalRechargeDetails && (
        <div>
          <TransactionRechargeModal
            onClose={(v) => {
              setOpenModalRechargeDetails(v);
            }}
            onClick={() => {
              setOpenModalRechargeDetails(false);
            }}
            transactionsDetails={transaction}
          />
        </div>
      )}
    </div>
  );
};
